$(function(){
	$('.js-delivery').on('click', function(){
		$(this).find('input').prop("checked", true);
        // var details = $(this).next('.js-delivery-details');
		var details = $('.js-delivery-details');
		details.fadeIn();
		details.addClass('active');
		$('.js-delivery-details').not(details).fadeOut(0);

	});
    $('.js-add-adress').on('click',function(){
        $('.js-form-adress').show(400);
        $(this).hide(400);
    });
});
